<template>
  <div class="enter_innovation_wrap">
    <div class="enter_img" :style="{'background': `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${pageData.bannerImage || require('../../assets/img/banner22.png')}) center/cover no-repeat`}">
      <div class="img_tit hidden-xs-only">{{ pageData.title || $t('europeLine.title') }}</div>
      <div class="img_desc hidden-xs-only">
        {{ pageData.subTitle || $t('europeLine.subtitle') }}
      </div>
      <div class="img_tit hidden-sm-and-up">
        {{ pageData.title || $t('europeLine.title') }}<br />{{ pageData.subTitle || $t('europeLine.subtitle') }}
      </div>
    </div>
    <div class="current_show_menu">
      <!-- 航线介绍区域 -->
      <div class="route_introduction">
        <div class="enter_title_wrap">
          <div class="enter_inner">
            <div class="inner_left">
              <img src="../../assets/img/tupianright.png" alt="" />
            </div>
            <div class="inner_center">
              <div class="enter_title">{{ $t('europeLine.introduction.title') }}</div>
              <div class="enter_desc">{{ $t('europeLine.introduction.description') }}</div>
            </div>
            <div class="inner_right">
              <img src="../../assets/img/tupianleft.png" alt="" />
            </div>
          </div>
        </div>
        <div class="introduction_content">
          <el-row :gutter="30" type="flex" justify="center">
            <el-col 
              v-for="(item, index) in introList" 
              :key="index" 
              :span="8" 
              :xs="24" 
              class="introduction_item"
            >
              <div class="introduction_card">
                <h3>{{ item.title }}</h3>
                <p>{{ item.content }}</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 航线图展示区域 -->
      <div class="route_map_wrap">
        <div class="enter_title_wrap">
          <div class="enter_inner">
            <div class="inner_left">
              <img src="../../assets/img/tupianright.png" alt="" />
            </div>
            <div class="inner_center">
              <div class="enter_title">{{ $t('europeLine.network.title') }}</div>
              <div class="enter_desc">{{ $t('europeLine.network.description') }}</div>
            </div>
            <div class="inner_right">
              <img src="../../assets/img/tupianleft.png" alt="" />
            </div>
          </div>
        </div>
        <div class="route_images">
          <div class="route_images_single">
            <div v-if="routeImages[0]" class="route_image_item_single">
              <div class="image_container_single">
                <img :src="routeImages[0]" alt="欧洲航线图1" />
              </div>
            </div>
            <div v-if="routeImages[1]" class="route_image_item_single">
              <div class="image_container_single">
                <img :src="routeImages[1]" alt="欧洲航线图2" />
              </div>
            </div>
            <div v-if="!routeImages[0] && !routeImages[1]" class="no-images-message">
              暂无航线图数据
            </div>
          </div>
        </div>
      </div>

      <!-- 服务优势 -->
      <div class="service_advantages">
        <div class="enter_title_wrap">
          <div class="enter_inner">
            <div class="inner_left">
              <img src="../../assets/img/tupianright.png" alt="" />
            </div>
            <div class="inner_center">
              <div class="enter_title">{{ $t('europeLine.advantages.title') }}</div>
              <div class="enter_desc">{{ $t('europeLine.advantages.description') }}</div>
            </div>
            <div class="inner_right">
              <img src="../../assets/img/tupianleft.png" alt="" />
            </div>
          </div>
        </div>
        <div class="advantages_content">
          <el-row :gutter="30" type="flex" justify="center">
            <el-col 
              v-for="(item, index) in advantageList" 
              :key="index" 
              :span="8" 
              :xs="24" 
              class="advantage_item"
            >
              <div class="advantage_card">
                <div class="advantage_icon">{{ ['🚀', '📍', '👥'][index] }}</div>
                <h3>{{ item.title }}</h3>
                <p>{{ item.desc }}</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 服务内容 -->
      <div class="service_content">
        <div class="enter_title_wrap">
          <div class="enter_inner">
            <div class="inner_left">
              <img src="../../assets/img/tupianright.png" alt="" />
            </div>
            <div class="inner_center">
              <div class="enter_title">{{ $t('europeLine.services.title') }}</div>
              <div class="enter_desc">{{ $t('europeLine.services.description') }}</div>
            </div>
            <div class="inner_right">
              <img src="../../assets/img/tupianleft.png" alt="" />
            </div>
          </div>
        </div>
        <div class="func_wrap">
          <div class="func_wrap_inner">
            <!-- 桌面端显示 -->
            <el-row class="func_card hidden-xs-only" type="flex">
              <el-col
                class="card_item"
                v-for="(item, index) in serviceList"
                :key="index"
                :span="5"
              >
                <div class="item_top" :style="{'background': item.bg}">
                  <p>{{ item.tit }}</p>
                </div>
                <div class="item_bottom">
                  <p v-for="(item2, index2) in item.desc" :key="index2">
                    {{ '○  ' + item2 }}
                  </p>
                </div>
              </el-col>
            </el-row>
            
            <!-- 移动端显示 -->
            <el-row class="func_card_mobile hidden-sm-and-up" type="flex" justify="center">
              <el-col
                class="card_item_mobile"
                v-for="(item, index) in serviceList"
                :key="index"
                :span="24"
              >
                <div class="item_top_mobile" :style="{'background': item.bg}">
                  <p>{{ item.tit }}</p>
                </div>
                <div class="item_bottom_mobile">
                  <p v-for="(item2, index2) in item.desc" :key="index2">
                    {{ '○  ' + item2 }}
                  </p>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>

    <!-- 页面页脚 - 与首页一致 -->
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import { getEuropeLineData } from '../../api/europe-line'
import CallMe from '../callme/index'
import MobileCallme from '../callme/MobileCallme.vue'
export default {
  components: {
    CallMe,
    MobileCallme
  },
  data() {
    return {
      pageData: {
        title: '',
        subTitle: '',
        bannerImage: ''
      },
      routeImages: [],
      introList: [],
      advantageList: [],
      serviceList: [],
    }
  },
  methods: {
    getGradientColor(index) {
      const gradients = [
        'linear-gradient(135deg, #3498db, #2ecc71)',
        'linear-gradient(135deg, #e74c3c, #e67e22)',
        'linear-gradient(135deg, #9b59b6, #34495e)',
        'linear-gradient(135deg, #1abc9c, #16a085)'
      ];
      return gradients[index] || gradients[0];
    },
    
    async loadPageData() {
      try {
        console.log('开始加载欧洲专线数据...');
        const response = await getEuropeLineData();
        console.log('API响应:', response);
        
        if (response.data && response.data.data) {
          const data = response.data.data;
          console.log('后端数据:', data);
          
          // 设置页面标题和副标题 - 严格使用后端数据
          if (data.banner) {
            this.pageData = {
              title: data.banner.title,
              subTitle: data.banner.subTitle,
              bannerImage: data.banner.bannerImage
            };
            console.log('横幅数据设置完成:', this.pageData);
          }

          // 设置航线介绍数据 - 严格使用后端数据
          if (data.intro && data.intro.length > 0) {
            this.introList = data.intro;
            console.log('航线介绍数据设置完成:', this.introList);
          }

          // 设置服务优势数据 - 严格使用后端数据
          if (data.advantage && data.advantage.length > 0) {
            this.advantageList = data.advantage;
            console.log('服务优势数据设置完成:', this.advantageList);
          }

          // 设置航线图图片 - 严格使用后端数据
          if (data.routeImages) {
            this.routeImages = [
              data.routeImages.image1,
              data.routeImages.image2
            ];
            console.log('航线图数据设置完成:', this.routeImages);
          }

            // 设置服务内容数据 - 严格使用后端数据
          if (data.service && data.service.length > 0) {
            console.log('原始服务数据:', data.service);
            this.serviceList = data.service.map((service, index) => {
              const mappedService = {
                tit: service.title,
                desc: service.desc,
                bg: this.getGradientColor(index)
              };
              console.log(`服务${index + 1}映射结果:`, mappedService);
              return mappedService;
            });
            console.log('服务内容数据设置完成:', this.serviceList);
          } else {
            console.log('服务内容数据为空或未找到');
          }
        } else {
          console.log('API响应数据为空');
        }
      } catch (error) {
        console.error('加载欧洲专线数据失败:', error);
      }
    }
  },
  mounted() {
    this.loadPageData();
  },
}
</script>

<style lang="scss" scoped>
.enter_innovation_wrap {
  width: 100%;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  
  .enter_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    text-align: center;
    
    .img_tit {
      font-size: 60px;
      font-weight: bold;
      text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
      margin-bottom: 20px;
      @media screen and (max-width: 768px) {
        font-size: 1.8rem;
        margin-bottom: 15px;
      }
    }
    .img_desc {
      font-size: 28px;
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
      max-width: 800px;
      line-height: 1.4;
      @media screen and (max-width: 768px) {
        font-size: 1rem;
        padding: 0 20px;
      }
    }
  }

  .enter_title_wrap {
    width: 100%;
    margin-top: 80px;
    @media screen and (max-width: 768px) {
      margin-top: 50px;
    }
    
    .enter_inner {
      display: flex;
      justify-content: center;
      align-items: center;
      
      .inner_left, .inner_right {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        
        img {
          width: 80px;
          height: 80px;
          opacity: 0.7;
          @media screen and (max-width: 768px) {
            width: 40px;
            height: 40px;
          }
        }
      }
      
      .inner_center {
        flex: 2;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 40px;
        
        .enter_title {
          font-size: 42px;
          font-weight: bold;
          color: #2c3e50;
          margin-bottom: 15px;
          position: relative;
          
          &::after {
            content: '';
            position: absolute;
            bottom: -10px;
            left: 50%;
            transform: translateX(-50%);
            width: 80px;
            height: 3px;
            background: linear-gradient(90deg, #3498db, #2ecc71);
            border-radius: 2px;
          }
          
          @media screen and (max-width: 768px) {
            font-size: 1.5rem;
          }
        }
        
        .enter_desc {
          font-size: 18px;
          color: #7f8c8d;
          text-align: center;
          line-height: 1.6;
          margin-top: 25px;
          @media screen and (max-width: 768px) {
            font-size: 0.9rem;
            margin-top: 15px;
          }
        }
      }
    }
  }

  .current_show_menu {
    padding: 60px 0;
    
    .route_introduction {
      .introduction_content {
        width: 90%;
        max-width: 1200px;
        margin: 60px auto;
        @media screen and (max-width: 768px) {
          width: 95%;
          margin: 40px auto;
        }
        
        .introduction_item {
          margin-bottom: 40px;
          
          .introduction_card {
            background: linear-gradient(145deg, #ffffff, #f8f9fa);
            border-radius: 20px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
            padding: 40px 30px;
            height: 100%;
            transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            border: 1px solid rgba(255, 255, 255, 0.8);
            position: relative;
            overflow: hidden;
            
            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              height: 4px;
              background: linear-gradient(90deg, #3498db, #2ecc71);
            }
            
            &:hover {
              transform: translateY(-10px) scale(1.02);
              box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
            }
            
            h3 {
              font-size: 26px;
              font-weight: bold;
              color: #2c3e50;
              margin-bottom: 25px;
              text-align: center;
              position: relative;
              
              &::after {
                content: '';
                position: absolute;
                bottom: -8px;
                left: 50%;
                transform: translateX(-50%);
                width: 40px;
                height: 2px;
                background: #3498db;
              }
              
              @media screen and (max-width: 768px) {
                font-size: 22px;
              }
            }
            
            p {
              font-size: 16px;
              line-height: 1.8;
              color: #5d6d7e;
              margin-bottom: 20px;
              text-align: justify;
              
              @media screen and (max-width: 768px) {
                font-size: 14px;
                line-height: 1.6;
              }
            }
          }
        }
      }
    }

    .route_map_wrap {
      .route_images {
        width: 90%;
        max-width: 1200px;
        margin: 60px auto;
        @media screen and (max-width: 768px) {
          width: 95%;
          margin: 40px auto;
        }
        
        .route_images_single {
          display: flex;
          flex-direction: column;
          gap: 60px;
          
          .route_image_item_single {
            margin-bottom: 0;
            
            .image_container_single {
              background: #fff;
              border-radius: 20px;
              box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
              overflow: hidden;
              transition: all 0.4s ease;
              border: 1px solid rgba(255, 255, 255, 0.8);
              
              &:hover {
                transform: translateY(-10px);
                box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2);
              }
              
              img {
                width: 100%;
                height: 600px;
                object-fit: contain;
                transition: transform 0.4s ease;
                
                &:hover {
                  transform: scale(1.03);
                }
                
                @media screen and (max-width: 768px) {
                  height: 400px;
                }
              }
              
              .image_title_single {
                padding: 25px;
                text-align: center;
                font-size: 24px;
                font-weight: bold;
                color: #2c3e50;
                background: linear-gradient(135deg, #f8f9fa, #e9ecef);
                border-top: 1px solid #e9ecef;
                
                @media screen and (max-width: 768px) {
                  font-size: 20px;
                  padding: 20px;
                }
              }
            }
          }
          
          .no-images-message {
            text-align: center;
            padding: 60px;
            font-size: 18px;
            color: #7f8c8d;
            background: #f8f9fa;
            border-radius: 15px;
            border: 2px dashed #dee2e6;
          }
        }
      }
    }

    .service_advantages {
      .advantages_content {
        width: 90%;
        max-width: 1200px;
        margin: 60px auto;
        @media screen and (max-width: 768px) {
          width: 95%;
          margin: 40px auto;
        }
        
        .advantage_item {
          margin-bottom: 40px;
          
          .advantage_card {
            background: linear-gradient(145deg, #ffffff, #f8f9fa);
            border-radius: 20px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
            padding: 40px 30px;
            height: 100%;
            transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            border: 1px solid rgba(255, 255, 255, 0.8);
            text-align: center;
            position: relative;
            overflow: hidden;
            
            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              height: 4px;
              background: linear-gradient(90deg, #3498db, #2ecc71);
            }
            
            &:hover {
              transform: translateY(-10px) scale(1.02);
              box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
            }
            
            .advantage_icon {
              font-size: 60px;
              margin-bottom: 25px;
              display: block;
              transition: transform 0.3s ease;
            }
            
            &:hover .advantage_icon {
              transform: scale(1.1);
            }
            
            h3 {
              font-size: 24px;
              font-weight: bold;
              color: #2c3e50;
              margin-bottom: 20px;
              position: relative;
              
              &::after {
                content: '';
                position: absolute;
                bottom: -8px;
                left: 50%;
                transform: translateX(-50%);
                width: 40px;
                height: 2px;
                background: #3498db;
              }
              
              @media screen and (max-width: 768px) {
                font-size: 20px;
              }
            }
            
            p {
              font-size: 16px;
              line-height: 1.6;
              color: #5d6d7e;
              margin: 0;
              
              @media screen and (max-width: 768px) {
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }

  .func_wrap {
    width: 100%;
    padding: 80px 0;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    min-height: 400px;
    
    .func_wrap_inner {
      width: 90%;
      max-width: 1200px;
      margin: 0 auto;
      @media screen and (max-width: 768px) {
        width: 95%;
      }
      
      .func_card {
        justify-content: space-between;
        margin-top: 50px;
        
        .card_item {
          background: rgba(255, 255, 255, 0.95);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
          border-radius: 20px;
          overflow: hidden;
          transition: all 0.4s ease;
          border: 1px solid rgba(255, 255, 255, 0.8);
          
          &:hover {
            transform: translateY(-10px);
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
          }
          
          .item_top {
            width: 100%;
            height: 180px;
            font-size: 26px;
            font-weight: bold;
            color: #fff;
            background: linear-gradient(135deg, #3498db, #2ecc71);
            background-size: cover;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            overflow: hidden;
            
            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: rgba(0, 0, 0, 0.1);
            }
            
            p {
              position: relative;
              z-index: 2;
              text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
            }
          }
          
          .item_bottom {
            padding: 25px 20px;
            
            p {
              font-size: 16px;
              margin-top: 15px;
              color: #5d6d7e;
              line-height: 1.6;
              position: relative;
              padding-left: 20px;
              
              &::before {
                content: '●';
                position: absolute;
                left: 0;
                color: #3498db;
                font-weight: bold;
              }
            }
          }
        }
      }

      .func_card_mobile {
        margin-top: 30px;
        
        .card_item_mobile {
          margin-bottom: 20px;
          
          .item_top_mobile {
            width: 100%;
            height: 120px;
            font-size: 20px;
            font-weight: bold;
            color: #fff;
            background: linear-gradient(135deg, #3498db, #2ecc71);
            background-size: cover;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            overflow: hidden;
            border-radius: 15px 15px 0 0;
            
            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: rgba(0, 0, 0, 0.1);
            }
            
            p {
              position: relative;
              z-index: 2;
              text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
            }
          }
          
          .item_bottom_mobile {
            background: rgba(255, 255, 255, 0.95);
            padding: 20px 15px;
            border-radius: 0 0 15px 15px;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
            
            p {
              font-size: 14px;
              margin-top: 10px;
              color: #5d6d7e;
              line-height: 1.5;
              position: relative;
              padding-left: 15px;
              
              &::before {
                content: '●';
                position: absolute;
                left: 0;
                color: #3498db;
                font-weight: bold;
              }
            }
          }
        }
      }
    }
  }
}
</style>
